export const GROUP_PAGE_ROOT = 'Group-wrapper';
export const MEDIA_GALLERY = 'media-gallery';
export const MEMBERS_TAB = 'members-tab';
export const PENDING_MEMBERS_EXPAND = 'pending-members-expand';
export const GROUP_HEADER = 'group-header';
export const GROUP_NOT_FOUND_DATA_HOOK = 'GROUP_NOT_FOUND_DATA_HOOK';
